import styled from '@emotion/styled'

import { Space } from '../../atoms'

export const TablePaginationContainer = styled(Space)`
  height: 30px;
  select {
    background: var(--White95);
    border: 1px solid var(--White90);
    outline: none;
    &:focus {
      background: var(--White95);
      border: 1px solid var(--White90);
      outline: none;
    }
  }
`

interface NavigationProps {
  isLeftNavigation: boolean
}

export const TablePaginationNavigation = styled.div<NavigationProps>`
  justify-content: ${props => (props.isLeftNavigation ? 'flex-start' : 'flex-end')};
  display: flex;
  flex-direction: row;
  align-items: center;
  background: none;
  border: none;
`
